import { inject, RendererFactory2, DOCUMENT } from '@angular/core';
import { AccessibilityModule, AccessibilityModuleConfigs } from '../accessibility-module.interfaces';
import * as i0 from "@angular/core";
export let AccessibilityBlueFilterHandler = /*#__PURE__*/(() => {
  class AccessibilityBlueFilterHandler {
    constructor() {
      this.doc = inject(DOCUMENT);
      this.renderer = inject(RendererFactory2).createRenderer(null, null);
      this.overlay = this.renderer.createElement('div');
      this.renderer.setStyle(this.overlay, 'background', 'rgba(255, 141, 28, .44)');
      this.renderer.setStyle(this.overlay, 'mix-blend-mode', 'multiply');
      this.renderer.setStyle(this.overlay, 'zIndex', '99999');
      this.renderer.setStyle(this.overlay, 'pointerEvents', 'none');
      this.renderer.setStyle(this.overlay, 'position', 'fixed');
      this.renderer.setStyle(this.overlay, 'width', 'auto');
      this.renderer.setStyle(this.overlay, 'height', 'auto');
      this.renderer.setStyle(this.overlay, 'top', '0');
      this.renderer.setStyle(this.overlay, 'bottom', '0');
      this.renderer.setStyle(this.overlay, 'left', '0');
      this.renderer.setStyle(this.overlay, 'right', '0');
    }
    onUpdate(enabled, config) {
      if (enabled && config.intensity > 0.0) {
        this.renderer.setStyle(this.overlay, 'opacity', config.intensity);
        this.renderer.appendChild(this.doc.body, this.overlay);
      } else {
        this.renderer.removeChild(this.doc.body, this.overlay);
      }
    }
    static {
      this.ɵfac = function AccessibilityBlueFilterHandler_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AccessibilityBlueFilterHandler)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: AccessibilityBlueFilterHandler,
        factory: AccessibilityBlueFilterHandler.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AccessibilityBlueFilterHandler;
})();